/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ShopWrapper_landingPage$ref = any;
export type collectionsLandingRootQueryVariables = {
    readonly landingPreviewId?: string | null;
    readonly listPreviewId?: string | null;
};
export type collectionsLandingRootQueryResponse = {
    readonly viewer: {
        readonly landingPage: {
            readonly title: string | null;
            readonly seoTitle: string | null;
            readonly seoDescription: string | null;
            readonly " $fragmentRefs": ShopWrapper_landingPage$ref;
        } | null;
    } | null;
};
export type collectionsLandingRootQuery = {
    readonly response: collectionsLandingRootQueryResponse;
    readonly variables: collectionsLandingRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "landingPreviewId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "listPreviewId",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "landingPreviewId",
    "variableName": "landingPreviewId"
  },
  {
    "kind": "Variable",
    "name": "listPreviewId",
    "variableName": "listPreviewId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "seoTitle",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "seoDescription",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "collectionsLandingRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "landingPage",
            "name": "collectionsLandingPage",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "LandingPage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ShopWrapper_landingPage",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "collectionsLandingRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "landingPage",
            "name": "collectionsLandingPage",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "LandingPage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "hero",
                "storageKey": null,
                "args": null,
                "concreteType": "LandingPageHero",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LandingPageHeroItem",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "linkPosition",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "grid",
                "storageKey": null,
                "args": null,
                "concreteType": "LandingPageGrid",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LandingPageGridItem",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "list",
                "storageKey": null,
                "args": null,
                "concreteType": "LandingPageList",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "listGroups",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LandingPageListGroup",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "listItems",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LandingPageListItem",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "collectionsLandingRootQuery",
    "id": "app-buyer-misc/235.0.0-2019-10-03T13:16:54.297Z/collectionsLandingRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7c2be20089201f8f2dd3ef87bcd2ead5';
export default node;
